import { gql } from '@apollo/client';
export const ProfileFragment = gql `
  fragment ProfileFragment on Profile {
    userId
    email
    name
    picture
    verified
  }
`;
export const AccountFragment = gql `
  fragment AccountFragment on CompanyUser2 {
    id
    role
    userId
    companyId
    canManageMember
    company {
      id
      name
      marketCode
      ssoEnterprise
    }
  }
`;
